import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { translatable } from 'react-instantsearch-core';
import { createClassNames } from "../core/utils.js";
var cx = createClassNames('ClearRefinements');
var ClearRefinements = /*#__PURE__*/function (_Component) {
  _inherits(ClearRefinements, _Component);
  var _super = _createSuper(ClearRefinements);
  function ClearRefinements() {
    _classCallCheck(this, ClearRefinements);
    return _super.apply(this, arguments);
  }
  _createClass(ClearRefinements, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        items = _this$props.items,
        canRefine = _this$props.canRefine,
        refine = _this$props.refine,
        translate = _this$props.translate,
        className = _this$props.className;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(cx(''), className)
      }, /*#__PURE__*/React.createElement("button", {
        className: cx('button', !canRefine && 'button--disabled'),
        onClick: function onClick() {
          return refine(items);
        },
        disabled: !canRefine
      }, translate('reset')));
    }
  }]);
  return ClearRefinements;
}(Component);
_defineProperty(ClearRefinements, "propTypes", {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  canRefine: PropTypes.bool.isRequired,
  refine: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  className: PropTypes.string
});
_defineProperty(ClearRefinements, "defaultProps", {
  className: ''
});
export default translatable({
  reset: 'Clear all filters'
})(ClearRefinements);